import React from 'react';
import {TextWarning} from './styles';

export default ({status = 'normal', message, display = ''}: {status?: string; message: string; display?: string}) => (
  <TextWarning status={status} display={display}>
    {message}
  </TextWarning>
);
